var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLangSingapore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2940_58424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 34C30.4183 34 34 30.4183 34 26C34 21.5817 30.4183 18 26 18C21.5817 18 18 21.5817 18 26C18 30.4183 21.5817 34 26 34Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 26C18 21.5818 21.5817 18 26 18C30.4183 18 34 21.5818 34 26",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8697 22.173C22.8697 21.0075 23.6888 20.0338 24.7827 19.7949C24.6146 19.7582 24.4402 19.7383 24.261 19.7383C22.9162 19.7383 21.8262 20.8283 21.8262 22.1731C21.8262 23.5178 22.9162 24.6078 24.261 24.6078C24.4401 24.6078 24.6145 24.5879 24.7827 24.5512C23.6888 24.3123 22.8697 23.3386 22.8697 22.173Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 19.9121L26.1727 20.4435H26.7315L26.2794 20.772L26.4521 21.3034L26 20.975L25.5479 21.3034L25.7206 20.772L25.2686 20.4435H25.8273L26 19.9121Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6446 20.9551L24.8172 21.4865H25.376L24.924 21.815L25.0966 22.3464L24.6446 22.018L24.1925 22.3464L24.3652 21.815L23.9131 21.4865H24.4719L24.6446 20.9551Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3555 20.9551L27.5282 21.4865H28.0869L27.6348 21.815L27.8076 22.3464L27.3555 22.018L26.9034 22.3464L27.0761 21.815L26.624 21.4865H27.1828L27.3555 20.9551Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.834 22.5215L27.0067 23.0529H27.5654L27.1134 23.3814L27.286 23.9128L26.834 23.5844L26.3819 23.9128L26.5546 23.3814L26.1025 23.0529H26.6613L26.834 22.5215Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1665 22.5215L25.3392 23.0529H25.898L25.4459 23.3814L25.6186 23.9128L25.1665 23.5844L24.7144 23.9128L24.8871 23.3814L24.4351 23.0529H24.9938L25.1665 22.5215Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2940_58424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangSingapore);
export default __webpack_public_path__ + "static/media/lang-Singapore.4928b9905d6d7d7905f88ee3d29b2908.svg";
export { ForwardRef as ReactComponent };